import { Anchor, Breadcrumbs, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router-dom';
import { NAV } from '../routes/adminNav.js';

/**
 * Built from the URL and the nav table rather than declared per page, so a new
 * route gets its trail for free. A segment with no nav entry is an id (a dealer
 * page, say) and reads as "Details" instead of a raw subscription id.
 */
export function PageBreadcrumbs() {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean); // ['app', 'dealers', '<id>']

  const trail = [{ label: 'Console', to: '/app' }];
  let acc = '';
  segments.slice(1).forEach((seg, i) => {
    acc += `/${seg}`;
    const nav = NAV.find((n) => n.to === `/app${acc}`);
    trail.push({
      label: nav?.label ?? (i === 0 ? seg.charAt(0).toUpperCase() + seg.slice(1) : 'Details'),
      to: `/app${acc}`,
    });
  });

  // Overview is the root; "Console > Overview" would only repeat itself.
  if (trail.length === 1) trail[0] = { label: 'Overview', to: '/app' };

  return (
    <Breadcrumbs separator={<IconChevronRight size={13} />} separatorMargin={6} aria-label="Breadcrumb">
      {trail.map((t, i) =>
        i === trail.length - 1 ? (
          <Text key={t.to} size="sm" fw={600} truncate>
            {t.label}
          </Text>
        ) : (
          <Anchor key={t.to} component={Link} to={t.to} size="sm" c="dimmed">
            {t.label}
          </Anchor>
        ),
      )}
    </Breadcrumbs>
  );
}
